module.exports = "<md-input-container flex-gt-xs>\n  <md-icon>date_range</md-icon>\n  <label>{{$ctrl.title}}</label>\n  <input\n    class=\"color-dark\"\n    ng-model=\"$ctrl.dateValue\"\n    ng-focus=\"$ctrl.open($event)\"\n  />\n</md-input-container>\n<md-icon ng-if=\"$ctrl.dateValue\" ng-click=\"$ctrl.clear()\" class=\"clear\">\n  close\n</md-icon>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/dateFilter/dateFilter.html
// module id = 845
// module chunks = 0